import React from "react";
import { useNavigate } from "react-router-dom";
import TagButton from "../common/TagButton";
import backgroundImage from "../../assets/Home/background_01.svg";
import OfferingsBot from "../../assets/Home/OfferingsBot.svg";
import OfferingsCarbon from "../../assets/Home/OfferingsCarbon.svg";

const OurOfferingCard = ({ svg, text, subtext, link }) => {
  const navigate = useNavigate();

  return (
    <div
      className="group w-full lg:max-w-[562px] h-full lg:max-h-[350px] flex-shrink-0 rounded-[20px] border border-[#D9D9D9] bg-[#FFF] px-[20px] py-[20px] lg:px-[50px] lg:py-[65px] hover:scale-[102%] transition-all duration-300 cursor-pointer"
      onClick={() => navigate(link)}
    >
      <img className="md:w-[54px] md:h-[54px]" src={svg} alt="" />
      <div>
        <h3 className="text-[#16012C] font-montserrat text-[16px] md:text-[24px] not-italic font-medium leading-[40px] md:leading-[60px] tracking-[-0.72px]">
          {text}
        </h3>
        <p className="text-[#64607D] h-[90px] md:h-auto font-roboto text-[16px] not-italic font-light leading-[22px] md:leading-[30px] tracking-[-0.32px]">
          {subtext}
        </p>
        <p className="lg:mt-[24px] text-t-blue-1 flex items-center gap-[4px] font-semibold font-montserrat cursor-pointer px-10 py-[12px] border-t-blue-1 border max-w-max rounded-sm transition-all duration-300 group-hover:bg-t-blue-1 group-hover:text-white hover:bg-t-blue-1 hover:text-white">
          Know More
        </p>
      </div>
    </div>
  );
};

const OurOfferings = () => {
  return (
    <div
      className="w-full flex justify-center h-[900px] lg:h-[743px] items-center relative bg-no-repeat bg-cover"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="absolute inset-0 pointer-events-none z-0"></div>
      <div className="flex w-full md:max-w-[1200px] flex-col md:items-start items-center gap-[36px] relative z-10 px-[20px] lg:px-0">
        <div className="flex flex-col gap-[36px] font-montserrat lg:w-[811px] md:mt-[36px]">
          {/* Out Offerings button */}
          <TagButton text={"Our Offerings"} />
          <div className="flex flex-col gap-[16px]">
            <div className=" text-white text-[24px] md:text-[40px] font-semibold leading-8 md:leading-[53.24px] self-stretch">
              Operationalize AI. The Right Way.
            </div>
            <div className="text-white text-[16px] font-normal leading-[28px]">
              We build enterprise grade AI agents and co-engineer
              production-grade AI systems that go beyond pilots — and into
              day-to-day ops.
            </div>
          </div>
        </div>
        <div className="flex lg:flex-row flex-col gap-[36px] lg:gap-[76px]">
          <OurOfferingCard
            svg={OfferingsBot}
            text="Build Enterprise AI Agents"
            subtext="Domain-specific, task-oriented AI agents are built to plug into your enterprise tools, workflows, and data."
            link={"/offering-a"}
          />
          <OurOfferingCard
            svg={OfferingsCarbon}
            text="Develop AI Products"
            subtext="AI features are co-developed with your teams to accelerate GTM and ship faster with shared ownership and tight engineering alignment."
            link={"/offering-b"}
          />
        </div>
      </div>
    </div>
  );
};

export default OurOfferings;
